/**
 * Format a date as a human-readable relative time string
 * (e.g. "5 minutes ago", "just now", "in 3 days").
 *
 * Wraps the formatting library used internally so call sites stay
 * implementation-agnostic. Swap the impl here if locale, suffix style,
 * or library changes.
 */
import { formatDistanceToNow } from 'date-fns';

export function relativeTime(date: Date): string {
  return formatDistanceToNow(date, { addSuffix: true });
}
